import { Button } from 'antd'
import { FC } from 'react'
import { RowNode } from '@/presentation/common/components/dataGrid/lib/api.types.ts'
import { useCrud } from '@/presentation/common/hooks/crud/useCrud.ts'
import { useMaintainerStore } from '@/presentation/common/store/zustand/maintainer.ts'
import { DeleteProductsTemplateProductFormProps } from '@/presentation/productsTemplates/forms/types.ts'
import {
  useDeleteProductsTemplatesProducts,
} from '@/presentation/productsTemplates/hooks/useDeleteProductsTemplatesProducts.ts'
import {
  QueryProductsTemplateProductsForTableResult,
} from '@/presentation/productsTemplates/hooks/useQueryProductsTemplateProductsForTable.ts'

export const DeleteMaintenanceProductsForm: FC<DeleteProductsTemplateProductFormProps> = ({ onCancel, onFinish }) => {
  const messageApiKey = 'DeleteMaintenanceProductForm-alert'
  const { submit, isSuccess, isLoading, isError, message } = useDeleteProductsTemplatesProducts()
  useCrud({ messageApiKey, message, isSuccess, isLoading, isError })

  const selectionNodes = useMaintainerStore(state => state.selectionV2)
  const ids = selectionNodes.map((node: RowNode<QueryProductsTemplateProductsForTableResult['items'][0]>) => node.data.id)

  const onConfirmDelete = async () => {
    if (isLoading) {
      return
    }

    await submit({ ids })
    onFinish?.call(this)
  }

  return (
    <>
      <p className="text-center mb-6">
                Está apunto de eliminar los productos seleccionados ({ids.length}).<br/>
                ¿Desea continuar con esta operación?
      </p>
      <div className="flex justify-center gap-2.5 pb-2">
        <Button size="small" type="primary" onClick={onCancel} disabled={isLoading}>Cancelar</Button>
        <Button size="small" type="primary" danger onClick={onConfirmDelete}
          disabled={isLoading}>Eliminar</Button>
      </div>
    </>
  )
}
